import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import apiService from '../../services/api.service'
import { useSelector } from 'react-redux'
import { createApiCase } from 'helper/create.api.case'

export const getShowroomList = createAsyncThunk(
    'getShowroomList',
    async (payload, thunkAPI) => {
        try {
            const response = await apiService.getShowroomList(payload)
            return response
        } catch (error) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

export const createShowroom = createAsyncThunk(
    'createShowroom',
    apiService.createShowroom
)

export const updateShowroom = createAsyncThunk(
    'updateShowroom',
    apiService.updateShowroom
)

export const deleteShowroom = createAsyncThunk(
    'deleteShowroom',
    apiService.deleteShowroom
)

export const initialData = {
    settingSort: {
        active_page: 1,
        start: 0,
        length: 10,
        search: '',
        delete_loading: false,
    },
    showroomData: {
        list: [],
        total: 0,
        loading: false,
    },

    formLoading: false,
    updateLoading: false,
    createLoading: false,
}

const dataSlice = createSlice({
    name: 'setting/data',
    initialState: initialData,
    reducers: {
        setSettingSort: (state, action) => {
            state.settingSort = action.payload
        },
        clearSettingSort: (state, action) => {
            state.settingSort = {
                active_page: 1,
                start: 0,
                length: 10,
                search: '',
                delete_loading: false,
            }
        },
    },
    extraReducers: (builder) => {
        createApiCase(builder, createShowroom, {
            loading: 'formLoading',
        })
        createApiCase(builder, updateShowroom, {
            loading: 'formLoading',
        })
        builder
            .addCase(getShowroomList.pending, (state) => {
                state.showroomData.loading = true
                state.settingSort.delete_loading = false
            })
            .addCase(getShowroomList.fulfilled, (state, action) => {
                state.showroomData.loading = false
                state.settingSort.delete_loading = false

                state.showroomData.list = action.payload.data
                state.showroomData.total =
                    action.payload.data.iTotalDisplayRecords
            })
            .addCase(getShowroomList.rejected, (state) => {
                state.showroomData.loading = false
                state.settingSort.delete_loading = false
            })
            .addCase(deleteShowroom.pending, (state) => {
                state.showroomData.loading = true
                state.settingSort.delete_loading = true
            })
            .addCase(deleteShowroom.fulfilled, (state, action) => {
                state.showroomData.loading = true
                state.settingSort.delete_loading = false
            })
            .addCase(deleteShowroom.rejected, (state) => {
                state.showroomData.loading = false
                state.settingSort.delete_loading = false
            })
    },
})

export const { setSettingSort, clearSettingSort } = dataSlice.actions

export default dataSlice.reducer
